import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, HostListener, OnDestroy, OnInit, Output } from '@angular/core';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { FileOperationsController } from '@commoncore/controller/FileOperationsController';
import { UserloginController } from '@commoncore/controller/UserLoginController';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { TeamFolderService } from '@commoncore/services/team-folder.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { AlbumsController } from '@mainrepo/app/core/controller/AlbumsController';
import { PeoplesTabController } from '@mainrepo/app/core/controller/PeoplesTabController';
import { Subject, Subscription } from 'rxjs';
import { PreviewImplementation } from '../../../core/implementation/PreviewImplementation';
import { GlobalService } from '../../../core/services/global.service';
import { ActiveRepo } from '../../../core/services/universal.service';
declare var clevertap: any;

export enum KEY_CODE {
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37
}
 
@Component({
  selector: 'lib-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})
export class PreviewComponent implements OnInit, OnDestroy,AfterViewInit {
  @Output() setFavorite = new EventEmitter();
  @Output() unSetFavorite = new EventEmitter();
  @Output() setShare = new EventEmitter();

  public universalService:any;
  public impl:any;
  public fileOpsService:any;
  public contextMenuService:any;
  public openMoreOptions:boolean = false;
  public loggerService:any;
  fileOperController:any;
  localStorageService:any;
  sessionStorageService:any;
  sub:Subscription;
  unFavEvent:Subscription;
  slideShowInterval: any;
  albumsController:any;
  peopleTabController:any;
  router:any
  shareAccessService: any;
  shareController: any;
  controller:any;
  public listService:any;
  cleverTapEventsService:any;
  containerHeightCalc:any;
  contextMenuMobileService: any;
  ppfToken:any;
  customMetadata: any;
  redirectionService:any;
  route:any;
  constructor(private changeDetectorRef: ChangeDetectorRef,public globalService:GlobalService) {
    this.setEnvObjects(this.globalService);
  }

  //Handling Swipe gestures for Desktop and Mobile
  onSwipe(event) {
    var classRef = this;
    if(this.universalService.isMobileDevice) {
      const x =
        Math.abs(
          event.deltaX) > 40 ? (event.deltaX > 0 ? "Right" : "Left") : "";
      const y =
        Math.abs(
          event.deltaY) > 40 ? (event.deltaY > 0 ? "Down" : "Up") : "";
      if (x == "Right") {
        classRef.fetchPrevious();
      } else if (x == "Left") {
        classRef.fetchNext();
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.universalService.checkDeviceType();
    if(this.universalService.userLoggedIn && (this.universalService.selectedFile["libreOfficeSupported"] || this.universalService.selectedFile["OfficeForWebSupported"]) && this.universalService.selectedFile["format"] != 'PDF' && this.universalService.activeRepo != ActiveRepo.SHARE){
      if(this.universalService.isMobileDevice){
        this.containerHeightCalc.calculateHeight('.docEditFrameCont iframe',null,120);
      } else {
        jQuery(".docEditFrameCont iframe").height('100%');
      }
    }

    if(this.universalService.isMobileDevice && this.universalService.activeRepo == 'main' && this.universalService.currentTab == 'audio'){
      this.universalService.showMiniPlayer = false;
      this.universalService.showAudioPreviewForFilter = true;
      this.universalService.showAudioWaves = true;
    }else{
      this.universalService.showAudioPreviewForFilter = false;
      if(!this.universalService.isMobileDevice && this.universalService.currentTab == 'audio' && this.universalService.activeRepo == 'main'){
        this.universalService.showAudioWaves = true;
      }else{
        this.universalService.showAudioWaves = false;
      }
    }
  } 

  @HostListener('document:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {

    if(this.router.url.includes("/audio") && !this.universalService.isMobileDevice && (event.keyCode === KEY_CODE.RIGHT_ARROW || event.keyCode === KEY_CODE.LEFT_ARROW) && this.universalService.popUpToBeOpened == "") {
      return false;
    }

    if (event.keyCode === KEY_CODE.RIGHT_ARROW && !this.universalService.showFileInfo && !this.universalService.isPreviewOpenFromSearchDropdown && !this.impl.fileForPreview["previewFromUpload"]) {
      if (this.universalService.onFullScreen) {
        this.universalService.onFullScreen = false;
        var self = this;
        document.exitFullscreen()
          .then(() => {
            self.fetchNext();
            setTimeout(() => {
              self.changeDetectorRef.detectChanges();
            }, 2000);
          })
          .catch((err) => console.error(err))
      } else {
        if (this.impl.isPreviewOpen && !this.universalService.operationInProgress) {
          this.fetchNext();
        } else {
          return
        }
      }
    }

    if (event.keyCode === KEY_CODE.LEFT_ARROW && !this.universalService.showFileInfo && !this.universalService.isPreviewOpenFromSearchDropdown && !this.impl.fileForPreview["previewFromUpload"]) {
      if (this.universalService.onFullScreen) {
        this.universalService.onFullScreen = false;
        var self = this;
        document.exitFullscreen()
          .then(() => {
            self.fetchPrevious();
            setTimeout(() => {
              self.changeDetectorRef.detectChanges();
            }, 2000);
          })
          .catch((err) => console.error(err))
      } else {
        if (this.impl.isPreviewOpen && !this.universalService.operationInProgress) {
          this.fetchPrevious();
        } else {
          return
        }
      }

    }
  }

  @HostListener('document:fullscreenchange', ['$event'])
  onFullScreenChange(ev: Event) {
    if(!this.universalService.virtualGridEnabled){
      this.containerHeightCalc.calculateHeight('.scrollableContainer',['.pseudo-header','.pseudo-top-header','.pseudo-banner-container'],54)        // <-----    typings of the argument `ev`
    }
    if (this.universalService.onFullScreen){
        this.universalService.onFullScreen = false;
        setTimeout(() => {
          if(this.universalService.selectedFile["mimeType"] == 'image' || this.universalService.selectedFile["mimeType"] == 'video'){
            this.recalculateDimensionsForPreview()
          }
      }, 800);
    }
  };
  


  async ngOnInit() {
    this.universalService.operationInProgress = false;
    AppEvents.objectPreview = new Subject();
    AppEvents.objectPreview.subscribe(async ev=>{
      if(ev["openPreview"]){
        this.setEnvObjects(this.globalService);
        this.initComp();
      }else if(ev["previewFromUpload"]){
        this.setEnvObjects(this.globalService);
        // if(this.universalService.selectedFile["objectKey"] == ev["objectDetails"]["objectKey"]) return
        this.fetchObjectMetadataAndOpenPreview(ev["objectDetails"])
      } else if(ev["closePreview"]){
        this.decideAction('closePreview');
      }
    })
    this.initComp();
  }
    
   async initComp(){
    this.impl = PreviewImplementation.getInstance(this.globalService);
    this.impl.setHandler(this.globalService);
    this.fileOperController = FileOperationsController.getInstance(this.globalService);
    this.fileOperController.setEnvObjects(this.globalService);
    if(this.universalService.selectedFile == "fileFromUpload"){
      this.impl.resetValuesForNextImage();
      return
    }
    await this.getPPFToken();
    this.impl.resetValuesBeforeShowingPreview();
    this.setRequiredData();
    let classRef = this;
    this.unFavEvent =  AppEvents.optionSelected.subscribe(event => {
      if(event['unFavFromFavPreview']){
        classRef.universalService.isUnFavInvoked = true;
        classRef.fetchNext()
      }
    })
    
  }

  ngAfterViewInit(): void {
    AppEvents.videoClapperEvent.subscribe(response => { 
      if(this.universalService.videoClapperRunning ){
        this.impl.mediaFiles = false; 
        this.impl.videoFiles = false;
        // this.sub = this.universalService.subject.subscribe((value) => { 
        //   this.changeDetectorRef.detectChanges();
        // });
      }else if(this.universalService.audioClapperRunning){
       
        this.impl.mediaFiles = false; 
        this.impl.audioFiles = false;
        // this.sub = this.universalService.subject.subscribe((value) => { 
        //   this.changeDetectorRef.detectChanges();
        // });
      }
    })
  }

  setEnvObjects(globalService){
    this.universalService = globalService.getUniversalServiceRef();
    this.fileOpsService = globalService.getFileOperationServiceRef();
    this.contextMenuService = globalService.getContextMenuServiceRef();
    this.loggerService = globalService.getLoggerServiceRef();
    this.router = globalService.getRouterRef();
    this.shareAccessService = this.globalService.getShareAccessServiceRef();
    this.listService = globalService.getListServiceRef();
    this.cleverTapEventsService =  globalService.getCleverTapEventsvc();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
    this.containerHeightCalc = this.globalService.getContainerHeightCalculatorService();
    this.contextMenuMobileService = this.globalService.getContextMenuMobileServiceRef();
    this.customMetadata = globalService.getCustomMetadataServiceRef();
    this.redirectionService = globalService.getRedirectionServiceRef();
    this.route = globalService.getActivatedRoute();
  }
  
  fullScreen(obj) {
    var elem = document.getElementById("myObject");
    if(obj.format == "image"){
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem['mozRequestFullScreen']) { /* Firefox */
        elem['mozRequestFullScreen']();
      } else if (elem['webkitRequestFullscreen']) { /* Chrome, Safari and Opera */
        elem['webkitRequestFullscreen']();
      } else if (elem['msRequestFullscreen']) { /* IE/Edge */
        elem['msRequestFullscreen']();
      }
      setTimeout(() => {
        this.universalService.onFullScreen = true;
        this.recalculateDimensionsForPreview();
      }, 500);
    }else{
      AppEvents.emit("FULLSCREEN");
    }
  }

  async fetchObjectMetadataAndOpenPreview(objDetails){
    let resp;
    try{
      resp = await this.impl.getObjectMetadataForPreview(objDetails);
      if(resp && resp["status"] == "A"){
        resp["previewFromUpload"] = true;
        resp["locationOfUpload"] = objDetails["locationOfUpload"];
        resp["uploadInitiatedModule"] = objDetails["uploadInitiatedModule"];
        resp["operationsWrapper"] = objDetails["operationsWrapper"];
        resp["operationsWrapper"] = objDetails["operationsWrapper"];
        resp["versioningSupported"] = objDetails["versioningSupported"];
        resp["officeForWebSupported"] = objDetails["officeForWebSupported"]
        resp = this.customMetadata.segregateData([resp],'allfiles');
        if(resp[0]["uploadInitiatedModule"] == "sharedFiles"){
          resp = this.customMetadata.setAccessRights(resp)
        }else if(resp[0]["uploadInitiatedModule"] == 'teamfolders'){
          let teamfolderService = new TeamFolderService();
          resp = teamfolderService.setCustomMetadataForTeamFolders(resp);
        }else if(resp[0]["uploadInitiatedModule"] == "Album Details"){
          resp = this.customMetadata.setOwnerDetails(resp)
        }
        this.universalService.selectedNodes = [];
        this.universalService.selectedNodes = resp;
        this.universalService.selectedFile = resp[0];
        this.universalService.showLoader = false;
        this.initComp();
      }else if(resp && (resp["status"] == "D" || resp["status"] == "T")){
        this.universalService.showLoader = false;
        this.universalService.showPreview = false;
        this.universalService.showToast(TOAST["OPEN_PREVIEW_FROM_UPLOAD_DELETED_ERROR"],"error");
        this.impl.closePreview();
      }
    }catch(err){
      if(err["error"]["code"] == "BRSOM0027"){
        this.universalService.showLoader = false;
        this.universalService.showPreview = false;
        this.universalService.showToast(TOAST["OPEN_PREVIEW_FROM_UPLOAD_DELETED_ERROR"],"error");
        this.impl.closePreview();
      }else{
        this.universalService.showLoader = false;
        this.universalService.showPreview = false;
        this.universalService.showToast(TOAST["OPEN_PREVIEW_FROM_UPLOAD_ERROR"],"error");
        this.impl.closePreview();
      }
    }
  }

  recalculateDimensionsForPreview(){
    this.universalService.selectedFile["height"] = null
    this.universalService.selectedFile["width"] = null
    this.universalService.selectedFile["top"] = null
    this.universalService.selectedFile["left"] = null
    this.impl.showPreviewModal(this.universalService.selectedFile);
  }


  previewErrorCheck(errorValue:String){
    if(errorValue == "error")
      this.impl.previewNotAvailable = true;
  }

  LoadingProgress(){
    this.universalService.showLoader = true;
  }

  LoadingFinish(){
    this.universalService.showLoader = false;
  }

  textLayerLoaded(){ // this is for redirecting the external links to a new tab in the PDF.
    var anchors = document.getElementById('pdf').getElementsByTagName('a'); 
    for (var i=0; i<anchors.length; i++)
    {
       anchors[i].setAttribute('target', '_blank');
    }
  }

  promoClicked(){
    clevertap.event.push("User_Screen_Tap", {
      "LOCATION":"Share_promotion"
    });
  }
  clientDownloadBtnClick(){
    clevertap.event.push("User_Screen_Tap", {
      "LOCATION":"Share_downlaod"
    });
  }

  ImageDoesnotExist(event){
    this.impl.previewNotAvailable = true;
  }

  isErrorinPreviewing(value){
    
    if(value){
      this.impl.previewNotAvailable = true
    }
  }

  addFavorite(){
    
    var object = this.fileOpsService.addFavorite();
    this.setFavorite.emit(object);
  }
  removeFavorite(){
    
    var object = this.fileOpsService.removeFavorite();
    this.unSetFavorite.emit(object);
  }

  async decideAction(action, event?: Event){
    this.albumsController = AlbumsController.getInstance(this.globalService);
    this.peopleTabController = PeoplesTabController.getInstance(this.globalService);
    if(!this.universalService.isMobileDevice) {
      this.universalService.operationInProgress = true;
    }
    if(action!='showMoreOptions' && action != 'openPreviewOptions')
      this.universalService.openMoreOptions = false;
    switch(action){
      case 'showMoreOptions':
        // event.stopPropagation();
        this.toggleMoreOptionsMenu();
        break;
      case 'addToJioCloud':
        this.fileOpsService.addtoJioCloud();
        break;
      case 'fullScreen':
        this.fullScreen(this.universalService.selectedPreviewFile);
        break;
      case 'downloadItems':
        this.downloadItems();
        break;
      case 'showFileInfo':
        this.cleverTapEventsService.fileInfoClicked(this.universalService.currentTab);
        if(!this.universalService.isMobileDevice){
          this.universalService.showObjectInfo(this.universalService.selectedPreviewFile)
          AppEvents.optionSelected.next({fileInfo: true});
        }else{
          this.universalService.openMobileFileInfo(this.universalService.selectedPreviewFile)
        }
        break;
      
      case 'closePreview':
        if(this.universalService.currentAlbum == undefined && (this.universalService.currentTab == 'Home' || this.router.url.includes('/filter/recents'))
           && !this.universalService.isPreviewOpenFromSearchDropdown && !this.router.url.includes("/search") && !window.location.href.includes("?u")){
            AppEvents.emit(EventsList.UPDATE_RECENT);
              //AppEvents.emit(EventsList.RECENT_UPLOAD_UPDATE);
        }
        if(this.shareAccessService.singleObjectShared != "" && this.universalService.userLoggedIn == true){
          this.shareAccessService.singleObjectShared = "";
          this.sessionStorageService.setSingleSharedObject(this.shareAccessService.singleObjectShared,true)
        }
        this.universalService.firstTimeHit = false;
        this.impl.clearAlbumInterval()
        this.impl.closePreview();
        break;
      case 'startSlideShow':
        this.startSlideShow();
        break;
    case "createShareLink":
      AppEvents.optionSelected.next({share: true});
      this.fileOpsService.createShareLink();
      break;
    case "getShareLink":
      this.cleverTapEventsService.publicShareLinkClick(this.universalService.currentTab)
      if(this.universalService.userLoggedIn){
        this.enhancedShareLink()
        //this.cleverTapEventsService.onShareGetLinkClick();
      }else{
        this.universalService.openCreateShareLink = true;
      }
      break;
    case "shareWithPeople":
      this.cleverTapEventsService.privateShareClick(this.universalService.currentTab);
      this.universalService.showShareWithPeople = true;
      AppEvents.optionSelected.next({shareWithPeople: true});
      break;
    case "addToAlbum":
      this.fileOpsService.addToAlbum();
      AppEvents.optionSelected.next({addtoalbum:true})
      break;
    case "renameObject":
      AppEvents.optionSelected.next({rename: true});
      this.fileOpsService.renameObject();
      break;
    case "deleteObject":
      this.fileOpsService.deleteItem();
      AppEvents.optionSelected.next({delete: true});
      break;
    case "addFavorite":
      this.addFavorite();
      this.contextMenuService.decideContextMenuItems();
      break;
    case "removeFavorite":
      this.removeFavorite();
      this.contextMenuService.decideContextMenuItems();
      break;
    case "move":
      this.fileOpsService.moveToSelectedPath();
      AppEvents.optionSelected.next({movecopy: true});
      this.setRequiredData();
      break;
    case "moveToPrivateFolder":
      this.cleverTapEventsService.moveToPf();
      this.fileOpsService.moveObjectToPrivateFolder();
     // this.setRequiredData();
      break;
    case "moveOutOfPF":
      this.cleverTapEventsService.moveOutOfPf();
      this.universalService.openMoreOptions = false;
      this.fileOpsService.moveOutOfPrivateFolder();
      break;
    case "copy":
      this.fileOpsService.copyInSelectedPath();
      AppEvents.optionSelected.next({movecopy: true});
      this.setRequiredData();
      break;
    case 'setAsCoverPic':
      var selectedObject = this.universalService.selectedFile
      this.albumsController.setEnvObjects(this.globalService);
      this.albumsController.setAsCoverPic(selectedObject);
      break;
    case "addHashTag":
      this.universalService.showMoreOptions = false;
      AppEvents.optionSelected.next({addHashTag:true});
      break;
    case "removeResults":
      AppEvents.peopleTabEvent.next({ showRemoveOptionsPopUp: true });
      break;
    case "setAsCoverPhoto":
      var selectedObject = this.universalService.selectedFile
      this.peopleTabController.setEnvObjects(this.globalService);
      this.peopleTabController.setAsCoverPhoto(selectedObject);
      break;
    case "manageVersions":
      this.cleverTapEventsService.manageVerDownloadClicked();
      AppEvents.optionSelected.next({manageVersions: true});
      break;
    case 'openPreviewOptions':
      if(!this.universalService.isMobileDevice){
        if(this.universalService.openMoreOptionsContextMenu){
          this.universalService.removeHighlightFromSelectedOption();
          this.universalService.openMoreOptionsContextMenu = false;
          this.universalService.operationInProgress = false;
          this.contextMenuService.hideCustomMoreOptionsContextMenu();
        }else{
          this.universalService.highlightSelectedOption(action)
          this.universalService.openMoreOptionsContextMenu = true;
        }
      }else{
        this.universalService.showMobOptionMenu = false;
        this.universalService.openMobileTopMoreOptionMenu();
        this.universalService.showModalBackdrop();
        this.contextMenuService.decideContextMenuItems();
        this.universalService.moreOptionsOnMobileClicked = true;
        this.contextMenuMobileService.decideMoreOptionsOnSubMenu(this.universalService.selectedFile,action);
      }
      break;
    case 'openWithOfficeForWeb':
      var file = this.universalService.selectedFile["FullObject"] ? this.universalService.selectedFile["FullObject"] : this.universalService.selectedFile;
      var moduleType = this.fileOpsService.getModuleType(file);
      this.listService.deSelectAll(null);
      if(this.universalService.iframeLogin){
        var logincontroller = UserloginController.getInstance(this.globalService);
        var autoLoginUrl = await logincontroller.getAutoLogionToken();
        var token = autoLoginUrl["url"].split("?t=")[1];
        var msAuthUrl = "/a?t=" + token + "&msofficepreview=" + moduleType;
        window.open(msAuthUrl, "_blank", "noopener, noreferrer");
        return;
      }
      if(this.universalService.currentAlbum == undefined && (this.universalService.currentTab == 'Home' || this.router.url.includes('/filter/recents'))) {
        var fileOperController = FileOperationsController.getInstance(this.globalService);
        fileOperController.setEnvObjects(this.globalService);
        fileOperController.setAccessedDate(file);
        setTimeout(() => {
          AppEvents.emit(EventsList.UPDATE_RECENT);
        }, 500);
      }

      if(file["format"] == "SpreadSheet"){
        this.cleverTapEventsService.msOfficeClicked('Excel')
      }else if(file["format"] == "Document"){
        this.cleverTapEventsService.msOfficeClicked('Word')
      }else if(file["format"] == "Presentation"){
        this.cleverTapEventsService.msOfficeClicked('Powerpoint')
      }

      window.open(window.location.origin + '/document/editor/' + file["objectKey"] + "/" + moduleType , "_blank", "noopener, noreferrer");
      break;
    case "showFileLocation":
      if(this.universalService.selectedFile){
        let parentObject = this.universalService.selectedFile.parentObjectKey;
        this.fileOpsService.resetRequiredDataBeforeOpeningTheLocationOfSelectedFile();
        this.listService.deSelectAll();
        this.localStorageService.removeLocalProperty(LocalStorageProps.SEARCH_KEY)
        if(this.universalService.searchType == 'teamfolder'){
          this.sessionStorageService.setCurrentTeamFolder({folderKey:this.universalService.currentTeamFolder["objectKey"],tfKey:this.universalService.currentTeamFolder["tfKey"]});
          this.globalService.getFolderServiceRef().initialiseBreadCrumbs('1', this.universalService.rootTeamFolderName, null);
          this.globalService.getFolderServiceRef().manageBreadCrumbs(this.universalService.currentTeamFolder["objectKey"], this.universalService.currentTeamFolder["tfName"],this.universalService.currentTeamFolder, null);
          this.router.navigate(['/teamfolders', parentObject], { queryParams: { tfKey: this.universalService.currentTeamFolder["tfKey"] } , queryParamsHandling: 'merge'});
        }else{
          this.globalService.getFolderServiceRef().initialiseBreadCrumbs('1', this.universalService.rootFolderNameNew, null);
          this.router.navigate(["/allfiles", parentObject], {state:{"initBreadCrumbs" : true}});
        }
      }
      break;
    case "editPhoto":
        var file = this.universalService.selectedFile["FullObject"] ? this.universalService.selectedFile["FullObject"] : this.universalService.selectedFile;
        var moduleType = this.fileOpsService.getModuleType(file);
        moduleType = this.fileOpsService.setModuleDataForSavingTheEditedObject(file,moduleType,this.globalService.getFolderServiceRef().currentFolder)
        this.listService.deSelectAll(null);
        window.open(window.location.origin + '/jc-photo/editor/' + file["objectKey"] + "/" + moduleType, "_blank", "noopener, noreferrer");
        break;
      default:
        this.loggerService.log("option invalid")
    }
  }

  toggleMoreOptionsMenu(){
    this.universalService.openMoreOptions  = !this.universalService.openMoreOptions;
    this.universalService.openMoreOptionsContextMenu = false;
    if(this.universalService.openMoreOptions){
      this.universalService.operationInProgress = false;
    }
  }



  startSlideShow(){
    this.toggleMoreOptionsMenu();
    this.slideShowInterval = setInterval(()=>{
      this.loggerService.log("calling fetch next")
      this.fetchNext();
      },4000)
  }

  stopSlideShow(){
    this.loggerService.log("stopping the slide show")
    window.clearInterval(this.slideShowInterval)
  }


  ngOnDestroy() {
    if(this.sub != undefined) {
      this.sub.unsubscribe();
    }
    if(this.unFavEvent != undefined) {
      this.unFavEvent.unsubscribe();
    }
    
    
    this.impl.webUrl = null;
    this.impl.fileForPreview = null;
    this.impl.showPreviewButtons = null;
    this.impl.docType = null;
    this.impl.docUrl = null;
    this.impl.mediaFiles = null;
    this.impl.audioFiles = null;
    this.impl.videoFiles = null;
    this.impl.previewNotAvailable = null;
    this.impl.objectsForPreview = null;
    this.impl.togglePreviewButtonsTimer = null;
    this.impl.isPreviewOpen = null;
    this.impl.displayFactor = null;
    this.listService = null;
    this.impl.clapprImpl = null;
  }

  async fetchNext(){
    this.universalService.operationInProgress = false;
    this.impl.previewDirection = "next";
    this.impl.clearAlbumInterval()
    this.getPPFToken();
    await this.impl.fetchNext();
    setTimeout(() => {
      this.setRequiredData()
    });
  }

  async fetchPrevious(){
    this.universalService.operationInProgress = false;
    this.impl.previewDirection = "previous"
    this.impl.clearAlbumInterval()
    this.getPPFToken();
    await this.impl.fetchPrevious();
    setTimeout(() => {
      this.setRequiredData()
    });
  }

  async setRequiredData(){
    // if(this.universalService.currentAlbum == undefined){
      var file = this.impl.fileForPreview
      this.universalService.selectedFile = file
      // if(this.universalService.userLoggedIn && window.location.href.indexOf('albums') == -1 && 
      if(this.universalService.userLoggedIn && (file["libreOfficeSupported"] || file["OfficeForWebSupported"]) && this.universalService.selectedFile["format"] != 'PDF' && this.universalService.activeRepo != ActiveRepo.SHARE){
        let result = await this.impl.getDocEditURL(this.impl.fileForPreview);
        this.impl.editDocuments(file,result)
        if(this.universalService.isMobileDevice){
          this.containerHeightCalc.calculateHeight('.docEditFrameCont iframe',null,120);
        }  
      }else{
        $('.docEditFrameCont').addClass('hide');
      }
      if(!this.router.url.includes("privatefolder") && !this.universalService.isAlbumsView)
      await this.fileOperController.setAccessedDate(this.impl.fileForPreview);
    // }
  }
  enhancedShareLink() {
    AppEvents.optionSelected.next({showEnhancedShareLink:true});   
  }

  downloadItems(){
    AppEvents.globalObservable.next({"downloadItems": true,"files":this.universalService.selectedNodes});
  }

  async getPPFToken(){
    await this.listService.getPPFToken();
    this.ppfToken = encodeURIComponent(this.universalService.header_X_PPF_TOKEN)
  }
  redirectToSignin(){
    this.redirectionService.setRequestedUrlInLocalStorageWithExpiry(LocalStorageProps.INVITE_URL,window.location.href)
    window.location.href = "/signin" + "/?c=" + this.route.snapshot.queryParamMap.get('c');
  }
}

